import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=724accd4&scoped=true&"
import script from "./ActivityCard.vue?vue&type=script&lang=js&"
export * from "./ActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=724accd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724accd4",
  null
  
)

export default component.exports